// extracted by mini-css-extract-plugin
export default {"alert":"alert-fOuZ","default":"default-tb9f","success":"success-kTsa","warning":"warning-Ihdx","danger":"danger-utlH"};